// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
import DialogBox from '../commons/dialogBox/DialogBox';
// actions
import { closeChangeStatusModal, ACTION } from 'app/redux/actions/modal/change-status-modal.action';

class ChangeStatusModal extends Component {
  componentWillUnmount = () => this.onClose();

  onClose = () => this.props.options.dispatch(closeChangeStatusModal());

  onSubmit = () => {
    const { onConfirmModal, id, action: status } = this.props.options;

    if (onConfirmModal && onConfirmModal(id, status)) {
      this.onClose();
    }
  };

  render() {
    const { /*id, */ options } = this.props;
    let { isOpened: isOpen, action, title, loading, showCancelButton = true /*, error*/ } = options;

    const titleHeader = title ? title : '';
    const header = action === ACTION.ACTIVE ? 'Desativar ' + titleHeader : 'Ativar ' + titleHeader;

    const statusDescription = action === ACTION.ACTIVE ? 'desativar' : 'ativar ';
    const description = 'Você tem certeza que deseja ' + statusDescription + ' o registro?';

    const confirmation = action === ACTION.ACTIVE ? 'DESATIVAR' : 'ATIVAR';

    const optionsDialogBox = {
      isOpen,
      title: header,
      description,
      confirmationTerm: confirmation,
      loading,
      onClose: this.onClose,
      onSubmit: this.onSubmit,
      size: 'tiny',
      showCancelButton,
      image: null
    };
    return <DialogBox options={optionsDialogBox} />;
  }
}

ChangeStatusModal.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.object
};

export default ChangeStatusModal;
